import { render, staticRenderFns } from "./shbe_ni_cross_authorities.vue?vue&type=template&id=4ffdffc3"
import script from "./shbe_ni_cross_authorities.vue?vue&type=script&lang=js"
export * from "./shbe_ni_cross_authorities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports